import { TextField, type TextFieldProps } from './TextField';

interface MoneyInputProps extends Omit<TextFieldProps, 'value' | 'onChange' | 'type' | 'prefix'> {
  /** Raw text so the field can be empty; parse with toAmount(). */
  value: string;
  onChange: (value: string) => void;
}

/** ₹ amount input (whole rupees). */
export function MoneyInput({ value, onChange, ...rest }: MoneyInputProps) {
  return (
    <TextField
      type="number"
      inputMode="numeric"
      min={0}
      step={1}
      placeholder="0"
      mono
      prefix="₹"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      {...rest}
    />
  );
}
